<template>
  <div v-loading="loading" class="app-container">
    <div>
      <label style="padding-right:10px">{{ $t('common.domain') }}</label>
      <el-select
        v-model="selectedDomainID"
        class="search-select"
        type="select"
        style="width: 20%; padding-bottom: 10px"
        :placeholder="$t('common.domain')"
      >
        <el-option v-for="domain in domains" :key="domain.id" :label="domain.name" :value="domain.id" />
      </el-select>
      <span v-if="!selectedDomainID" class="required-field">{{ $t('common.required') }}</span>
    </div>
    <div style="padding-bottom:10px">
      <label style="padding-right:10px">{{ $t('common.startDate') }}</label>
      <el-date-picker v-model="startDate" :clearable="false" :value-format="dateValueFormat"> </el-date-picker>
      <span v-if="!startDate" class="required-field">{{ $t('common.required') }}</span>
    </div>
    <div style="padding-bottom:10px">
      <label style="padding-right:10px">{{ $t('common.endDate') }}</label>
      <el-date-picker v-model="endDate" :clearable="false" :value-format="dateValueFormat"> </el-date-picker>
      <span v-if="!endDate" class="required-field">{{ $t('common.required') }}</span>
    </div>
    <div style="padding-bottom:10px">
      <label style="padding-right:10px">{{ $t('orderLine.orderLineStatus') }}</label>
      <el-select
        v-model="selectedStatusID"
        clearable
        class="search-select"
        type="select"
        style="width: 20%; padding-bottom: 10px"
        :placeholder="$t('orderLine.orderLineStatus')"
      >
        <el-option v-for="status in orderLineStatuses" :key="status.id" :label="status.name" :value="status.id" />
      </el-select>
    </div>
    <div style="padding-bottom:10px">
      <label style="padding-right:10px">{{ $t('planning.group') }}</label>
      <el-select
        v-model="selectedPlanningOption"
        clearable
        class="search-select"
        type="select"
        style="width: 20%; padding-bottom: 10px"
        :placeholder="$t('planning.group')"
      >
        <el-option
          v-for="planningOption in planningOptions"
          :key="planningOption.code"
          :label="planningOption.description"
          :value="planningOption.code"
        />
      </el-select>
    </div>
    <editor-button
      :disabled="!selectedDomainID || !startDate || !endDate"
      button-translation="planning.exportSelection"
      action="primary"
      :icon-only="false"
      style="padding-bottom:10px;"
      @click="exportSelection()"
    />
    &nbsp;
  </div>
</template>
<script>
import EditorButton from '@/components/crud/EditorButton';
import { ForceFileDownload } from '@/utils/general';
import { toDutchDateString } from '@/utils/date';

export default {
  components: {
    EditorButton
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    initialValue: Array,
    caption: String,
    itemsProp: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dateValueFormat: 'yyyy-MM-dd',
      loading: false,
      selectedDomainID: this.$store.getters['domain/getDefaultSelectValueDomainID'],
      startDate: null,
      endDate: null,
      selectedStatusID: null,
      selectedPlanningOption: null
    };
  },
  computed: {
    domains() {
      return this.$store.getters.domains;
    },
    orderLineStatuses() {
      return this.$store.getters['orderLineStatus/loadedItems'];
    },
    planningOptions() {
      return this.$store.getters['option/loadedOptions']('planningOptions');
    }
  },
  created() {
    this.$store.dispatch('orderLineStatus/getItems');
  },
  methods: {
    exportSelection() {
      this.loading = true;
      this.$store
        .dispatch('report/orderReport', {
          domainID: this.selectedDomainID,
          startDate: this.startDate,
          endDate: this.endDate,
          statusID: this.selectedStatusID,
          planningOption: this.selectedPlanningOption
        })
        .then(blob => {
          ForceFileDownload(
            blob,
            `Datacomlijst ${toDutchDateString(this.startDate)} - ${toDutchDateString(this.endDate)}.xlsx`
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.required-field {
  padding-left: 5px;
  color: red;
}
</style>
